import { AppModal } from '@app/components/AppModal';
import AppAlert from '@app/components/AppAlert';
import { useState } from 'react';
import { archiveManyPotentielsParrainages } from '@app/api/data/potentiels-parrainages';
import AppLoading from '@app/components/AppLoading';

type props = {
    onSuccess: () => void;
    idToUpdate: number[];
    open: boolean;
    onClose: () => void;
};

export const ArchivePotentiels = ({
    idToUpdate,
    onSuccess,
    open,
    onClose,
}: props) => {
    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {
        setLoading(true);
        try {
            await archiveManyPotentielsParrainages(idToUpdate);
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Erreur lors de l\'archivage:', error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    return (
        <AppModal
            handleSubmit={submit}
            icon="ArchiveBoxIcon"
            title={`Archivage des potentiels parrainages`}
            submitText="Archiver"
            submitIcon="ArchiveBoxIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex min-w-[400px] flex-col">
                <label className="mb-4">
                    {idToUpdate.length} potentiel(s) parrainage(s) à archiver
                </label>
                {loading ? (
                    <AppLoading />
                ) : (
                    <AppAlert
                        message={{
                            color: 'warning',
                            title: 'Archivage des potentiels parrainages',
                            text: 'Archiver les potentiels parrainages sélectionnés ? Ils ne seront plus visibles dans les listes normales.',
                        }}
                    />
                )}
            </div>
        </AppModal>
    );
};
export default ArchivePotentiels;

